import { InfoIcon } from 'lucide-react'
import { ReactNode } from 'react'

import { cn } from '@/utils/cn'

import { Tooltip, TooltipContent, TooltipTrigger } from '../tooltip'

interface Props {
    children: ReactNode
    className?: string
}
export default function InfoToolTip({ children, className }: Props) {
    return (
        <Tooltip delayDuration={250}>
            <TooltipTrigger>
                <InfoIcon className={cn(className, 'block h-4 w-4')} />
            </TooltipTrigger>
            <TooltipContent>{children}</TooltipContent>
        </Tooltip>
    )
}
